import { typePrefix } from "./helpers";

export const CROSS_REGION_FETCH = typePrefix("FETCH");
